import React from "react";

import * as S from "./logo.styles";
import { Simpletax } from "./constants";

export const Logo = (props) => {
  const logo = props.company?.logo?.image
    ? props.company.logo.image
    : Simpletax.logo;
  const logoWidth = props.company?.logo?.width
    ? props.company.logo.width
    : Simpletax.width;

  return (
    <>
      <S.SimpletaxLogo
        alt={logo}
        src={logo}
        width={props.width ? props.width : logoWidth}
      ></S.SimpletaxLogo>
    </>
  );
};
